import { DailyApiUsage } from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getApiUsageKey } from '../../utils/keys/api-stats.key.js'

export const useApiUsages = (options?: {
  useQueryOptions?: UseQueryOptions<DailyApiUsage[]>
}) => {
  const { useQueryOptions } = options || {}
  const { client } = useTribeClient()

  return useQuery<DailyApiUsage[]>(
    getApiUsageKey(),
    () => client.network.apiUsages(),
    useQueryOptions,
  )
}
